export default __webpack_public_path__ + "static/media/DSC_0506.1588ba59.jpg";